import { useEffect, useRef } from "react";
import $ from "jquery";
export default function PdpVisualizerPopup({
  products,
  product,
  visualizerType,
}) {
  const visRef = useRef(null);
  const siteInfo = window.wpProductFilter.siteInfo;
  const domainApiKey = siteInfo.domainApiKey;

  const productIds = products
    .filter((item) => item.custom !== "")
    .map((item) => `${item.custom}`);

  useEffect(() => {
    // Load external script only once
    const script = document.createElement("script");
    script.src = "https://viz.broadlu.me/dist/visualiserLoader_v2.9.js";
    script.async = true;
    script.onload = () => {
      if (window.visualiserLoader) {
        let config = {
          download: true,
          product: product.custom,
          // product: "3BA8F0D0-67C2-4E16-9B69-16A8D05C4D75",
          // products: [
          //   "3B55622D-2454-45CD-871E-5B5D49C57A7E",
          //   "3BA8F0D0-67C2-4E16-9B69-16A8D05C4D75",
          //   "3BF60120-33EC-4445-BC3D-5477DB602A66",
          // ],
          bgcolor: "#221E20",
          activebgcolor: "#747474",
          fontcolor: "#FFFDF8",
          accent: "#A52F76",
          accentfontcolor: "#ffffff",
          loadingmessage: "Loading a fantastic visualizer, hold tight!...",
          loadingcolor: "#ff00ff",
        };

        if (visualizerType === "collection") {
          config = { ...config, products: productIds };
        }
        if (visualizerType === "product") {
          config = { ...config, type: "sku" };
        }
        // console.log(visualizerType);
        // console.log(visualizerType === "collection");
        // console.log(config);
        const productVisualizer = new window.visualiserLoader(
          visRef.current.id,
          domainApiKey,
          { desktopHeightPercent: 75, desktopWidthPercent: 95 },
          config,
          true,
          false
        );

        productVisualizer.addListener("allEvents", (data) => {
          console.log(
            "Event Received:",
            data.eventName,
            "Payload:",
            data.eventData
          );
        });
      }
    };
    document.body.appendChild(script);

    // Cleanup (optional, removes script if component unmounts)
    return () => {
      document.body.removeChild(script);
    };
  }, [visualizerType]);

  return (
    <>
      <div id="productVisualizer" ref={visRef}></div>
      {/* {product?.custom && product.custom != "" && (
        <script>
          {`
            //Visualiser config
            var config = {
                download: true,
                // catalog: true, //On full viz
                // duid: '314aa161-867a-4902-b780-35c62319b418', //This is the ID of our Hawkins test site, limiting to those products else it will try to load everything and be very slow!
                product: '${product.custom}',
                products: [${productIds}],
                bgcolor: '#221E20',
                activebgcolor: '#747474',
                fontcolor: '#FFFDF8',
                accent: '#A52F76',
                accentfontcolor: '#ffffff',
                loadingmessage: 'Loading a fantastic visualizer, hold tight!...',
                loadingcolor: '#ff00ff',
            };


            //Load the visualizer
            var productVisualizer = new visualiserLoader('productVisualizer','${domainApiKey}',{desktopHeightPercent:75, desktopWidthPercent: 80 },config,true,false); //local laptop

            // Can then listen to events if required
            productVisualizer.addListener('allEvents',function(data){
                console.log('Event Received:',data.eventName,"Payload:",data.eventData);
            });
          `}
        </script>
      )} */}
    </>
  );
}
